import type { IntegrationDefinition } from "gitpod-next-api/gitpod/v1/integration_pb";

/**
 * Returns true when the definition represents a GitHub App integration.
 */
export function isGitHubAppDefinition(definition: IntegrationDefinition): boolean {
    return definition.host === "github.com";
}
